module.exports = __webpack_public_path__ + "media/images/wowu_logo_white-77fd2f6e53b3ac4f7d2fdfab542ddcf7.svg";